import React from 'react';
import { Card, Col, DatePicker, Row, Typography } from 'antd';
import { get } from 'lodash';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';

dayjs.extend(customParseFormat);
dayjs.extend(isSameOrAfter);
dayjs.extend(isSameOrBefore);

import { TableList } from 'components/table-list';
import PdButton from 'components/pd-button';

import { priceFormat } from 'utils';

const { RangePicker } = DatePicker;
const { Text, Title } = Typography;

const Cashback = ({
  cashbackData,
  cashbackList,
  cashbackLoad,
  cashbackNext,
  loadMoreCashback,
}) => {
  const { amount = 0 } = cashbackData;

  const orderColumns = [
    {
      name: 'Date',
      selector: row => row.created_at,
      format: (row) => dayjs(get(row, 'created_at', '')).format('DD/MM/YYYY'),
      width: '30%',
    },
    {
      name: 'Description',
      selector: row => row.activity,
      width: '40%',
    },
    {
      name: 'Amount',
      selector: row => row.amount,
      width: '30%',
      format: (row) => `IDR  ${priceFormat(get(row, 'amount', ''))}`,
    },
  ];

  return (
    <Col span={24} className="section-container pd-reseller-detail-cashback">
      <div className=" inner-section">
        <Row className="summaryContent" type="flex" align="middle">
          <Col span={24}>
            <Title className="pageSubtitle" level={3}>
              Cashback
            </Title>
          </Col>
          <Col span={6}>
            <Card className="balance">
              <Text>Balance</Text>
              <Text strong>IDR {priceFormat(amount)}</Text>
            </Card>
          </Col>
          <Col span={6} offset={1}>
            <RangePicker className="w-full" />
          </Col>
          <Col span={24} className="pd-margin-top-md pd-reseller-detail-table">
            <TableList columns={orderColumns} orderList={cashbackList} />
          </Col>
          <Col span={3} offset={10}>
            {cashbackNext > 0 && (
              <PdButton
                onClick={loadMoreCashback}
                outline={true}
                type="primary">
                {cashbackLoad ? 'Loading...' : 'Load More'}
              </PdButton>
            )}
          </Col>
        </Row>
      </div>
    </Col>
  );
};

export default Cashback;
